var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:0.01;}.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{stroke:#475867;}.cls-3{stroke:#00a886;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_BG",
    "data-name": "White BG"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.05,
    cy: 30.65,
    r: 14.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.27,44.4v8.8a1.56,1.56,0,0,1-1.55,1.56H27.39a1.56,1.56,0,0,1-1.55-1.56V44.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.54,
    y1: 58.94,
    x2: 33.65,
    y2: 58.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.35,34.16a10.65,10.65,0,0,1-.87,1.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.05,19.78A10.88,10.88,0,0,1,42.93,30.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32,
    y1: 5.06,
    x2: 32,
    y2: 9.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.9,
    y1: 12.55,
    x2: 17.14,
    y2: 15.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.1,
    y1: 48.75,
    x2: 46.86,
    y2: 45.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.4,
    y1: 30.65,
    x2: 10.98,
    y2: 30.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.6,
    y1: 30.65,
    x2: 53.02,
    y2: 30.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.9,
    y1: 48.75,
    x2: 17.14,
    y2: 45.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.1,
    y1: 12.55,
    x2: 46.86,
    y2: 15.79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.9926e70bf20633180cb70a1bd90f2ce4.svg";
export { ForwardRef as ReactComponent };